import React from 'react';
import { Avatar } from '@instructure/ui-avatar';
import { Flex } from '@instructure/ui-flex';
import { Text } from '@instructure/ui-text';
import { NameDisplayFormat } from "../../../../util/gradebook/constants.js";
export var StudentCell = function StudentCell(_ref) {
  var student = _ref.student,
    secondaryInfo = _ref.secondaryInfo,
    _ref$showStudentAvata = _ref.showStudentAvatar,
    showStudentAvatar = _ref$showStudentAvata === void 0 ? true : _ref$showStudentAvata,
    nameDisplayFormat = _ref.nameDisplayFormat,
    studentPopover = _ref.studentPopover;
  var shouldShowStudentStatus = student.status === 'inactive' || student.status === 'concluded';
  var studentName = nameDisplayFormat === NameDisplayFormat.LAST_FIRST ? student.sortableName : student.displayName;
  return /*#__PURE__*/React.createElement(Flex, {
    height: "100%",
    "data-testid": "student-cell",
    gap: "small"
  }, showStudentAvatar && /*#__PURE__*/React.createElement(Flex.Item, {
    as: "div"
  }, /*#__PURE__*/React.createElement(Avatar, {
    as: "div",
    size: "x-small",
    name: studentName,
    src: student.avatarUrl,
    "data-testid": "student-avatar"
  })), /*#__PURE__*/React.createElement(Flex.Item, {
    as: "div",
    padding: "none x-small"
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    textAlign: "start"
  }, studentPopover, secondaryInfo !== void 0 && /*#__PURE__*/React.createElement(Text, {
    size: "legend",
    color: "secondary",
    "data-testid": "student-secondary-info"
  }, secondaryInfo))), shouldShowStudentStatus && /*#__PURE__*/React.createElement(Flex.Item, {
    "data-testid": "student-status"
  }, /*#__PURE__*/React.createElement("span", {
    className: "label"
  }, student.status)));
};